/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Bad_Jackal_BuildInputs */

const en_keen_bad_jackal_build = /** @type {(inputs: Keen_Bad_Jackal_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact support`)
};

const de_keen_bad_jackal_build = /** @type {(inputs: Keen_Bad_Jackal_BuildInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support kontaktieren`)
};

/**
* | output |
* | --- |
* | "Contact support" |
*
* @param {Keen_Bad_Jackal_BuildInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_bad_jackal_build = /** @type {((inputs?: Keen_Bad_Jackal_BuildInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Bad_Jackal_BuildInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_bad_jackal_build(inputs)
	return de_keen_bad_jackal_build(inputs)
});